/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S2_HeadingInputs */

const tr_cerez_s2_heading = /** @type {(inputs: Cerez_S2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Çerez Kategorilerimiz`)
};

const en_cerez_s2_heading = /** @type {(inputs: Cerez_S2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Our cookie categories`)
};

const de_cerez_s2_heading = /** @type {(inputs: Cerez_S2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Unsere Cookie-Kategorien`)
};

const ru_cerez_s2_heading = /** @type {(inputs: Cerez_S2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Наши категории файлов cookie`)
};

/**
* | output |
* | --- |
* | "2. Our cookie categories" |
*
* @param {Cerez_S2_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s2_heading = /** @type {((inputs?: Cerez_S2_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S2_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s2_heading(inputs)
	if (locale === "de") return de_cerez_s2_heading(inputs)
	if (locale === "ru") return ru_cerez_s2_heading(inputs)
	return tr_cerez_s2_heading(inputs)
});